const productGrid = document.getElementById('product-grid');
const loadMoreBtn = document.querySelector('.load-more_btn');
const loadMoreSpinner = document.querySelector('.load-more_spinner');
let nextUrl = document.getElementById('paginateNext').dataset.nextUrl;

async function getNextPage() {
  try {
    const response = await fetch(nextUrl);
    return await response.text();
  } catch (error) {
    console.error('Failed to fetch next page:', error);
    loadMoreBtn.style.display = 'flex'; // Ensure the button is shown in case of failure
  }
}

async function loadMoreProducts() {
  loadMoreBtn.style.display = 'none';
  loadMoreSpinner.style.display = 'block';

  const nextPage = await getNextPage();
  if (!nextPage) return; // If no new page, stop further processing

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  loadMoreSpinner.style.display = 'none';

  const newProductGrid = nextPageDoc.getElementById('product-grid');
  const newProducts = newProductGrid.getElementsByClassName('griditem');
  const fragment = document.createDocumentFragment(); // Create a fragment to append all new items at once

  Array.from(newProducts).forEach(product => fragment.appendChild(product));

  // Append new products to the main grid
  productGrid.appendChild(fragment);

  const newPagination = nextPageDoc.getElementById('paginateNext');
  const newNextUrl = newPagination?.dataset.nextUrl;

  if (newNextUrl) {
    loadMoreBtn.style.display = 'flex'; // Show the button if there's a next page
    nextUrl = newNextUrl;
  } else {
    loadMoreBtn.style.display = 'none'; // Hide button if no more pages
  }
}
